"use client";

import { QuantityStepper } from "@pamperedchef/design-system";

export interface QuantitySelectorProps {
	value: number;
	onChange: (value: number) => void;
	min?: number;
	max?: number;
	disabled?: boolean;
	errorMessage?: string;
}

export function QuantitySelector({
	value,
	onChange,
	min = 1,
	max = 99,
	disabled = false,
	errorMessage
}: QuantitySelectorProps) {
	return (
		<QuantityStepper
			initialValue={value}
			min={min}
			max={max}
			onChange={onChange}
			disabled={disabled}
			errorMessage={errorMessage}
			size="lg"
		/>
	);
}
